//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      tableData: [
        // {
        //   number: "1",
        //   person: "张三",
        //   time: "2022年 至 2023年",
        //   area: "1000",
        //   price: "800",
        //   total: "760000",
        // },
        // {
        //   number: "1",
        //   person: "张三",
        //   time: "2022年 至 2023年",
        //   area: "1000",
        //   price: "800",
        //   total: "760000",
        // },
      ],
    };
  },
};
